module.exports = __webpack_public_path__ + "images/for_company_page/plan-pr-pc_5f92518eefb3ad58ca1dd02950f67295.png";